import React, { useEffect, useRef, useState } from "react";
import { Badge, Button, Col, Input, Label, Row } from "reactstrap";
import { MenuItem } from "../../../../redux/menuSlice";
import {
  CREATE_ORDER_MENU_LIST_TITLE,
  CUSTOM_MENU_ITEM_TYPE,
  DEFAULT_IMAGE_URL,
  SET_MENU_ITEM_TYPE,
  SINGLE_ITEM_TYPE,
} from "../../../../constants/constans";
import "./index.css";
import { SetMenu } from "../../../../redux/setMenuSlice";
import { CustomMenuItem } from "../../../../redux/customizeMenuSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBowlFood,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faMinus,
  faPlus,
  faSliders,
  faTrash,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import CustomItemSetupModal from "./CustomItemSetupModal";
import ControlledSelect from "../../../../components/ControlledSelect";
import { toast } from "react-toastify";
import MenuListSkeleton from "../../../../components/MenuSkelton";
import { Modal } from "react-bootstrap";
import {
  getAvailableDayNames,
  getCurrentDayName,
  getImageUrlWithFallback,
} from "../../../../utility/Utility";
import { useLazyGetRestaurantFilterTagsQuery } from "../../../../redux/services/menuItemService";
import { useSelector } from "react-redux";

interface CollectItemsStepProps {
  setOrderItems: any;
  orderItems: any;
  scheduledOrderDetails: {
    isScheduledOrder: boolean;
    orderTimeSlot: string | null;
  };
  selectedMenu: any;
  setSelectedMenu: any;
  selectedMenuItemList: MenuItem[];
  setFilteredData: MenuItem[];
  setSelectedMenuItemList: any;
  menus: Menu[];
  singleMenuItemsList: MenuItem[];
  setSingleMenuItemsList: any;
  comboItemList: SetMenu[];
  setComboItemList: any;
  customMenuItemList: CustomMenuItem[];
  setCustomMenuItemList: any;
  control: any;
  sendCustomObj?: any;
  setSendCustomObj?: any;
  orderByWatcher?: any;
  isCanCollectItems: boolean;
  isInitialLoading: boolean;
  isTentativeOrder: boolean;
  watch: any;
  onDoneClick?: () => Promise<void> | void;
  manualDeliveryFeeError?: string;
  manualDiscountError?: string;
  cartSummariesData?: any;
  isInventoryLoading?: boolean;
  isDeliveryOrder?: boolean;
  cartId?: string;
  deliveryDate?: Date;
  organizationId?: string | null;
}

export interface Menu {
  isAvailable: boolean | undefined;
  id: string;
  createdAt: {
    _nanoseconds: number;
    _seconds: number;
  };
  displayName: string;
  dineType: string;
  servingTime: string;
  restaurantId: string;
  items: MenuItem[];
  status: string;
  supportedApps?: string[];
}

export interface CollectItem {
  isAvailable?: boolean | undefined;
  name?: string | undefined;
  id?: string;
  category?: any;
  description?: string;
  displayName?: string;
  imageUrl?: any;
  mealType?: string;
  menuItemId?: string;
  preparingTime?: number;
  price?: number;
  restaurantId?: string;
  isCustomMenuItem?: boolean;
  customMenuItemSection?: string;
  createdAt?: {
    _nanoseconds: number;
    _seconds: number;
  };
  itemType?: String;
  itemId?: String;
  quantity?: number;
  availableDays?: any;
  supportsPreOrdering?: boolean;
  supportPortionSizes?: boolean;
  portionLabel?: any;
  portions?: any;
  allergenInformation?: string[];
  foodAttributes?: string[];
  availableItemCount?: number;
  items?: any[];
  status?: string;
  updatedAt?: any[];
  extraItems?: any[];
  priceType?: string;
  sections?: any;
  totalItems?: number;
  customItemType?: string;
  calculatedPrice?: number;
  dimensions?: { [dimensionId: string]: { dimensionValueId: string } };
  isAddOn?: boolean;
  customItems?: {
    itemId: string;
    displayName: string;
    unitPrice: number;
    quantity?: number;
    isAddOn?: boolean;
  }[];
  customVariantKey?: string;
  customItemTotal?: number; // Pre-calculated total for custom menu items (base + extras)
  perItemManualDiscount?: number; // Manual discount per item
}

export interface CustomizedCustom {
  availableDays: any;
  priceType?: string;
  sections: any;
  totalItems: number;
  isAvailable?: boolean;
  id: string;
  displayName?: string;
  price: any;
  collectedItems: CollectItem[];
}

// const convertOrderTimeSlotToServingTimeFormat = (
//   orderTimeSlot: string | null
// ): string | null => {
//   return orderTimeSlot;
// };
// const isOrderTimeSlotInRange = (
//   orderTimeSlot: string | null,
//   servingTime: string
// ): boolean => {
//   if (!orderTimeSlot) return false;

//   const convertedOrderTimeSlot =
//     convertOrderTimeSlotToServingTimeFormat(orderTimeSlot);

//   if (!convertedOrderTimeSlot) return false;

//   const [orderStartTime, orderEndTime] = convertedOrderTimeSlot.split("-");
//   const [menuStartTime, menuEndTime] = servingTime.split("-");

//   const parseTimeToMilliseconds = (time: string): number => {
//     const [hours, minutes] = time.split(":").map(Number);
//     return new Date().setHours(hours, minutes, 0, 0);
//   };
//   const orderStart = parseTimeToMilliseconds(orderStartTime);
//   const orderEnd = parseTimeToMilliseconds(orderEndTime);
//   const menuStart = parseTimeToMilliseconds(menuStartTime);
//   const menuEnd = parseTimeToMilliseconds(menuEndTime);
//   return orderStart >= menuStart && orderEnd <= menuEnd;
// };

const CollectItemsStep: React.FC<CollectItemsStepProps> = ({
  orderItems,
  setOrderItems,
  selectedMenu,
  setSelectedMenu,
  selectedMenuItemList,
  setSelectedMenuItemList,
  setFilteredData,
  menus,
  singleMenuItemsList,
  comboItemList,
  customMenuItemList,
  setSingleMenuItemsList,
  setComboItemList,
  setCustomMenuItemList,
  control,
  setSendCustomObj,
  sendCustomObj,
  orderByWatcher,
  isCanCollectItems,
  scheduledOrderDetails,
  isInitialLoading,
  watch,
  onDoneClick,
  manualDeliveryFeeError,
  manualDiscountError,
  cartSummariesData,
  isInventoryLoading,
  isDeliveryOrder,
  cartId,
  deliveryDate,
  organizationId,
}) => {
  const restaurantId = useSelector((state: any) => state.restaurant.selectedRestaurantDetails.id);
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [showModal, setShowModal] = useState(false);
  const [selectedCustomItem, setSelectedCustomItem] = useState<MenuItem>();
  const [customizedCustomItem, setCustomizedCustomItem] =
    useState<CustomizedCustom>();
  const [selectedPortions, setSelectedPortions] = useState<{
    [key: string]: { additionalCost: number; label: string };
  }>({});
  const addItemLength = customizedCustomItem?.collectedItems.length;
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [triggerGetFilterTags, { data: fetchedFilterTagsData, isLoading: isFilterTagsLoading }] = useLazyGetRestaurantFilterTagsQuery();

  const [isDoneLoading, setIsDoneLoading] = useState<boolean>(false);
  const [showClearConfirm, setShowClearConfirm] = useState<boolean>(false);
  const [isMenuListCollapsed, setIsMenuListCollapsed] = useState<boolean>(true);
  const [searchValue, setSearchValue] = useState("");
  const searchInputRef = useRef<any>(null);

  const scroll = (direction: "left" | "right") => {
    const scrollAmount = 200;
    scrollRef.current?.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };
  const { isScheduledOrder, orderTimeSlot } = scheduledOrderDetails;
  const [showAvailabilityModal, setShowAvailabilityModal] = useState(false);
  const [name, setName] = useState("");
  const [availableDays, setAvailableDays] = useState<number[]>([]);
  const [selectedFilterTags, setSelectedFilterTags] = useState<string[]>([]);
  const [filterTagsData, setFilterTagsData] = useState<any>(null);
  const DEFAULT_CUSTOM_VARIANT_KEY = "__default__";

  const getCustomVariantKey = (item: any) => {
    return item?.customVariantKey || DEFAULT_CUSTOM_VARIANT_KEY;
  };

  const getResolvedMenuItemPrice = (menuItemRef: any, baseItem: any) => {
    return Number(
      menuItemRef?.overridePrice ??
      menuItemRef?.ovrridePrice ??
      menuItemRef?.price ??
      baseItem?.overridePrice ??
      baseItem?.ovrridePrice ??
      baseItem?.price ??
      0
    );
  };

  const getMenuLevelOverridePrice = (itemId?: string) => {
    if (!itemId) return undefined;

    const selectedMenuOverride = selectedMenu?.items?.find(
      (menuItem: any) =>
        menuItem?.itemId === itemId &&
        (menuItem?.overridePrice !== undefined || menuItem?.ovrridePrice !== undefined)
    );

    if (selectedMenuOverride) {
      return selectedMenuOverride?.overridePrice ?? selectedMenuOverride?.ovrridePrice;
    }

    for (const menu of menus || []) {
      const matched = menu?.items?.find(
        (menuItem: any) =>
          menuItem?.itemId === itemId &&
          (menuItem?.overridePrice !== undefined || menuItem?.ovrridePrice !== undefined)
      );
      if (matched) {
        return (matched as any)?.overridePrice ?? (matched as any)?.ovrridePrice;
      }
    }

    return undefined;
  };

  const withMenuOverridePrice = (item: any) => {
    const menuOverridePrice = getMenuLevelOverridePrice(item?.id);
    if (menuOverridePrice === undefined) return item;

    return {
      ...item,
      overridePrice: menuOverridePrice,
    };
  };

  const isSameOrderItemVariant = (
    orderItem: any,
    chooseItem: MenuItem,
    portionLabel: string,
    customVariantKey: string = DEFAULT_CUSTOM_VARIANT_KEY
  ) => {
    const isSameBaseItem =
      (orderItem?.id || orderItem?.menuItemId) === chooseItem.id &&
      (orderItem?.portionLabel || "") === portionLabel;

    if (!isSameBaseItem) return false;

    if (chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE) {
      return getCustomVariantKey(orderItem) === customVariantKey;
    }

    return true;
  };

  const getDefaultCustomOrderItem = (item: MenuItem, portionLabel: string) => {
    return orderItems.find((orderItem: any) =>
      isSameOrderItemVariant(orderItem, item, portionLabel, DEFAULT_CUSTOM_VARIANT_KEY)
    );
  };

  const getDefaultCustomOrderItemIndex = (item: MenuItem, portionLabel: string) => {
    return orderItems.findIndex((orderItem: any) =>
      isSameOrderItemVariant(orderItem, item, portionLabel, DEFAULT_CUSTOM_VARIANT_KEY)
    );
  };

  // Returns how many units of this item are already sitting in the local order draft
  // (summed across portions/variants), so the inventory badge can reflect what's
  // actually still free to add rather than raw backend stock alone.
  const getReservedQuantityInOrder = (itemId: string): number => {
    return orderItems.reduce((sum: number, orderItem: MenuItem) => {
      const orderItemId = orderItem?.id || orderItem?.menuItemId;
      if (orderItemId === itemId) {
        return sum + (orderItem?.quantity || 0);
      }
      return sum;
    }, 0);
  };

  // Inventory check utility function
  const checkInventoryAvailability = (itemId: string, requestedQuantity: number = 1): { available: boolean; availableCount: number; isLoading?: boolean; message?: string } => {
    // Skip inventory checks for scheduled orders with future delivery date - manufacturing team will manage future orders
    if (isScheduledOrder && deliveryDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const deliveryDay = new Date(deliveryDate);
      deliveryDay.setHours(0, 0, 0, 0);

      // Skip validation if delivery date is not today
        if (deliveryDay.getTime() !== today.getTime()) {
          return { available: true, availableCount: Infinity };
        }
      }

      // While the real-time inventory snapshot is (re)loading, don't fail open as "available" —
      // surface the loading state instead so the UI doesn't flash an incorrect status.
      if (isInventoryLoading) {
        return { available: true, availableCount: Infinity, isLoading: true };
      }

      if (!cartSummariesData || !cartSummariesData.carts) {
      // No inventory data available, allow the order (fail-open approach)
      return { available: true, availableCount: Infinity };
    }

    let totalAvailable = 0;
    // const channel = isDeliveryOrder ? 'WebDelivery' : 'WebPickup';

    if (isDeliveryOrder) {
      // For delivery orders, sum up available inventory from WebDelivery channel across all carts
      Object.values(cartSummariesData.carts).forEach((cart: any) => {
        if (cart.products && cart.products[itemId]) {
          const product = cart.products[itemId];
          if (product.channels && product.channels.WebDelivery) {
            const available = product.channels.WebDelivery.available || 0;
            totalAvailable += available;
          }
        }
      });
    } else {
      // For pickup orders, check specific cart's WebPickup channel
      if (cartId && cartSummariesData.carts[cartId]) {
        const cart = cartSummariesData.carts[cartId];
        if (cart.products && cart.products[itemId]) {
          const product = cart.products[itemId];
          if (product.channels && product.channels.WebPickup) {
            totalAvailable = product.channels.WebPickup.available || 0;
          }
        }
      }
    }

    // Net out what's already reserved locally in this order draft, so reducing/increasing
    // the pack count in the order table is reflected immediately in the displayed stock,
    // instead of waiting on the backend snapshot to resync.
    const reservedInOrder = getReservedQuantityInOrder(itemId);
    const remainingAvailable = Math.max(0, totalAvailable - reservedInOrder);

    const available = remainingAvailable >= requestedQuantity;
    let message = '';

    // if (!available) {
    //   if (remainingAvailable === 0) {
    //     message = `This item is currently out of stock for ${isDeliveryOrder ? 'delivery' : 'pickup'}.`;
    //   } else {
    //     message = `Only ${remainingAvailable} item(s) available for ${isDeliveryOrder ? 'delivery' : 'pickup'}. Please reduce the quantity.`;
    //   }
    // }

    return { available, availableCount: remainingAvailable, message };
  };

  useEffect(() => {
    if (isScheduledOrder && orderTimeSlot) {
    }
  }, [isScheduledOrder, orderTimeSlot]);

  // Fetch filter tags data
  useEffect(() => {
    // Get restaurant ID from Redux store instead of organizationId
    if (restaurantId) {
      triggerGetFilterTags(restaurantId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerGetFilterTags]);

  // Update local filter tags data when API response changes
  useEffect(() => {
    if (fetchedFilterTagsData) {
      setFilterTagsData(fetchedFilterTagsData);
    }
  }, [fetchedFilterTagsData]);
  const handlePortionSelect = (
    itemId: string,
    additionalCost: number,
    label: string
  ) => {
    setSelectedPortions((prev) => ({
      ...prev,
      [itemId]: { additionalCost, label },
    }));
  };

  // Filter functionality for menu items based on selected tags
  const filterBySelectedTag = (list: MenuItem[]): MenuItem[] => {
    // First filter out unavailable items
    const availableItems = list.filter(item => item.isAvailable !== false);

    if (selectedFilterTags.length === 0 || !filterTagsData?.filterTags) return availableItems;

    const normalizedSelectedTags = selectedFilterTags.map((tag) => tag.toLowerCase());
    const selectedGroupMap: Record<string, Set<string>> = {};

    // Create a mapping between API group names and item tag keys
    const groupKeyMapping: Record<string, string> = {
      'Brand': 'brand',
      'Class': 'class',
      'Cuisine': 'cuisine',
      'New Arrivals': 'new arrivals'
    };

    for (const [groupName, groupData] of Object.entries(filterTagsData.filterTags)) {
      // Type check groupData to ensure it has the expected structure
      if (groupData && typeof groupData === 'object' && 'tags' in groupData) {
        const tags = (groupData as any).tags;
        if (Array.isArray(tags)) {
          for (const tag of normalizedSelectedTags) {
            if (tags.some((t: any) => t.tag && t.tag.toLowerCase() === tag)) {
              const itemKey = groupKeyMapping[groupName] || groupName.toLowerCase();
              if (!selectedGroupMap[itemKey]) {
                selectedGroupMap[itemKey] = new Set();
              }
              selectedGroupMap[itemKey].add(tag);
            }
          }
        }
      }
    }

    return availableItems.filter((item) => {
      const itemTags = (item as any).tags;

      // If no tags, include item when no filters are selected, exclude when filters are active
      if (!itemTags || typeof itemTags !== 'object') {
        return false; // Exclude items without tags when filters are active
      }

      // Check if item matches ALL selected filter groups (AND logic between groups)
      for (const [itemKey, selectedTagsInGroup] of Object.entries(selectedGroupMap)) {
        const itemTagsForGroup = itemTags[itemKey] || [];

        if (Array.isArray(itemTagsForGroup)) {
          const normalizedItemTags = itemTagsForGroup.map((tag: any) =>
            typeof tag === 'string' ? tag.toLowerCase() : ''
          );
          const hasMatch = Array.from(selectedTagsInGroup).some((selectedTag) =>
            normalizedItemTags.includes(selectedTag)
          );
          if (!hasMatch) {
            return false;
          }
        } else if (typeof itemTagsForGroup === 'string') {
          // Handle case where tags might be a single string
          const hasMatch = Array.from(selectedTagsInGroup).includes(itemTagsForGroup.toLowerCase());
          if (!hasMatch) {
            return false;
          }
        } else {
          // No tags for this group - exclude item
          return false;
        }
      }
      return true;
    });
  };

  // Filter handlers
  const handleAllFilter = () => {
    setSelectedFilterTags([]);
  };

  const handleTagFilter = (tagObj: any, groupData: any, category: string) => {
    const isSelected = selectedFilterTags.includes(tagObj.tag);
    const allowMultiple = groupData && typeof groupData === 'object' && 'allowMultipleSelect' in groupData
      ? groupData.allowMultipleSelect
      : false;

    setSelectedFilterTags((prevTags) => {
      if (allowMultiple) {
        return isSelected
          ? prevTags.filter(tag => tag !== tagObj.tag)
          : [...prevTags, tagObj.tag];
      } else {
        // Single selection: toggle selection within this group.
        // Clicking an already-selected tag will unselect it; clicking another
        // tag will replace the group's selection with the clicked tag.
        const tags = groupData && groupData.tags && Array.isArray(groupData.tags) ? groupData.tags : [];
        const otherGroupTags = tags.map((t: any) => t.tag).filter((t: string) => t !== tagObj.tag);
        // Remove all other tags from this group; keep selections from other groups
        const filteredTags = prevTags.filter(tag => !otherGroupTags.includes(tag));
        if (isSelected) {
          // Unselect the clicked tag
          return filteredTags.filter(tag => tag !== tagObj.tag);
        } else {
          // Select the clicked tag (single-select behavior)
          return [...filteredTags, tagObj.tag];
        }
      }
    });
  };

  const hadaleSelectedMenu = (menu: Menu) => {
    let itemsArray: MenuItem[] = [];

    // Get the selected organization ID for corporate filtering
    const selectedOrganizationId = watch("organizationId") || organizationId;

    menu.items.forEach((item) => {
      if (item.itemType === "MenuItem") {
        const singleItem = singleMenuItemsList.find(
          (singleMenuItem) => item?.itemId === singleMenuItem?.id
        );
        if (singleItem) {
          // Filter corporate items based on organization
          if (menu.displayName?.toLowerCase() === "health packs" || menu.displayName?.toLowerCase() === "corporate") {
            // Only include items that are corporate products and belong to the selected organization
            if (singleItem.isCooporateProduct &&
              (singleItem as any).organizationIds &&
              Array.isArray((singleItem as any).organizationIds) &&
              selectedOrganizationId &&
              (singleItem as any).organizationIds.includes(selectedOrganizationId)) {
              itemsArray.push({
                ...singleItem,
                itemType: "MenuItem",
                price: getResolvedMenuItemPrice(item, singleItem),
                overridePrice:
                  item?.overridePrice ??
                  (item as any)?.ovrridePrice ??
                  (singleItem as any)?.overridePrice ??
                  (singleItem as any)?.ovrridePrice,
                quantity:
                  singleItem?.quantity === null ||
                    singleItem?.quantity === undefined
                    ? 0
                    : singleItem?.quantity,
              });
            }
          } else {
            // For non-corporate menus (including Add on), include all items
            itemsArray.push({
              ...singleItem,
              itemType: "MenuItem",
              price: getResolvedMenuItemPrice(item, singleItem),
              overridePrice:
                item?.overridePrice ??
                (item as any)?.ovrridePrice ??
                (singleItem as any)?.overridePrice ??
                (singleItem as any)?.ovrridePrice,
              quantity:
                singleItem?.quantity === null ||
                  singleItem?.quantity === undefined
                  ? 0
                  : singleItem?.quantity,
            });
          }
        }
        if (
          singleItem?.portionLabel === undefined &&
          singleItem?.portions !== undefined &&
          singleItem?.portions?.length > 0
        ) {
          handlePortionSelect(
            singleItem?.id,
            singleItem?.portions[0]?.additionalCost,
            singleItem?.portions[0]?.displayName
          );
        }
      } else if (item.itemType === "SetMenu") {
        const comboItem = comboItemList.find(
          (comboItem) => item?.itemId === comboItem?.id
        );

        if (comboItem) {
          // Filter corporate combo items based on organization
          if (menu.displayName?.toLowerCase() === "health packs" || menu.displayName?.toLowerCase() === "corporate") {
            // Only include items that are corporate products and belong to the selected organization
            if (comboItem.isCooporateProduct &&
              (comboItem as any).organizationIds &&
              Array.isArray((comboItem as any).organizationIds) &&
              selectedOrganizationId &&
              (comboItem as any).organizationIds.includes(selectedOrganizationId)) {
              itemsArray.push({
                ...comboItem,
                itemType: "SetMenu",
                price: getResolvedMenuItemPrice(item, comboItem),
                overridePrice:
                  item?.overridePrice ??
                  (item as any)?.ovrridePrice ??
                  (comboItem as any)?.overridePrice ??
                  (comboItem as any)?.ovrridePrice,
                quantity:
                  comboItem?.quantity === null || comboItem?.quantity === undefined
                    ? 0
                    : comboItem?.quantity,
              });
            }
          } else {
            // For non-corporate menus (including Add on), include all items
            itemsArray.push({
              ...comboItem,
              itemType: "SetMenu",
              price: getResolvedMenuItemPrice(item, comboItem),
              overridePrice:
                item?.overridePrice ??
                (item as any)?.ovrridePrice ??
                (comboItem as any)?.overridePrice ??
                (comboItem as any)?.ovrridePrice,
              quantity:
                comboItem?.quantity === null || comboItem?.quantity === undefined
                  ? 0
                  : comboItem?.quantity,
            });
          }
        }

        // initial portion[0] set
        if (
          comboItem?.portionLabel === undefined &&
          comboItem?.portions !== undefined &&
          comboItem?.portions?.length > 0
        ) {
          handlePortionSelect(
            comboItem?.id,
            comboItem?.portions[0]?.additionalCost,
            comboItem?.portions[0]?.displayName
          );
        }
      } else {
        const customizeItem = customMenuItemList.find(
          (customMenuItem) => item?.itemId === customMenuItem?.id
        );

        if (customizeItem) {
          // Filter corporate custom items based on organization
          if (menu.displayName?.toLowerCase() === "health packs" || menu.displayName?.toLowerCase() === "corporate") {
            // Only include items that are corporate products and belong to the selected organization
            if (customizeItem.isCooporateProduct &&
              (customizeItem as any).organizationIds &&
              Array.isArray((customizeItem as any).organizationIds) &&
              selectedOrganizationId &&
              (customizeItem as any).organizationIds.includes(selectedOrganizationId)) {
              itemsArray.push({
                ...customizeItem,
                itemType: "CustomMenu",
                price: getResolvedMenuItemPrice(item, customizeItem),
                overridePrice:
                  item?.overridePrice ??
                  (item as any)?.ovrridePrice ??
                  (customizeItem as any)?.overridePrice ??
                  (customizeItem as any)?.ovrridePrice,
                quantity:
                  customizeItem?.quantity === null ||
                    customizeItem?.quantity === undefined
                    ? 0
                    : customizeItem?.quantity,
              });
            }
          } else {
            // For non-corporate menus (including Add on), include all items
            itemsArray.push({
              ...customizeItem,
              itemType: "CustomMenu",
              price: getResolvedMenuItemPrice(item, customizeItem),
              overridePrice:
                item?.overridePrice ??
                (item as any)?.ovrridePrice ??
                (customizeItem as any)?.overridePrice ??
                (customizeItem as any)?.ovrridePrice,
              quantity:
                customizeItem?.quantity === null ||
                  customizeItem?.quantity === undefined
                  ? 0
                  : customizeItem?.quantity,
            });
          }
        }

        // initial portion[0] set
        if (
          customizeItem?.portionLabel === undefined &&
          customizeItem?.portions !== undefined &&
          customizeItem?.portions?.length > 0
        ) {
          handlePortionSelect(
            customizeItem?.id,
            customizeItem?.portions[0]?.additionalCost,
            customizeItem?.portions[0]?.displayName
          );
        }
      }
    });

    const menuItemList: MenuItem[] = itemsArray;

    setSelectedMenu(menu);
    setSelectedMenuItemList(menuItemList);
  };

  const handleUpdatedMenuItemsList = (chooseItem: MenuItem, value: number) => {
    if (chooseItem.itemType === SINGLE_ITEM_TYPE) {
      const updatedSingleMenuItemsList = singleMenuItemsList.map(
        (item: MenuItem) => {
          if (item.id === chooseItem.id) {
            return {
              ...item,
              quantity: (item?.quantity ?? 0) + value,
            };
          }
          return item;
        }
      );
      setSingleMenuItemsList(updatedSingleMenuItemsList);
    } else if (chooseItem.itemType === SET_MENU_ITEM_TYPE) {
      const updatedComboMenuItemsList = comboItemList.map((item: MenuItem) => {
        if (item.id === chooseItem.id) {
          return {
            ...item,
            quantity: (item?.quantity ?? 0) + value,
          };
        }
        return item;
      });
      setComboItemList(updatedComboMenuItemsList);
    } else if (chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE) {
      const updatedCustomMenuItemsList = customMenuItemList.map(
        (item: MenuItem) => {
          if (item.id === chooseItem.id) {
            return {
              ...item,
              quantity: (item?.quantity ?? 0) + value,
            };
          }
          return item;
        }
      );
      setCustomMenuItemList(updatedCustomMenuItemsList);
    }
  };

  const handleUpdatedSelectedMenuItemList = (
    chooseItem: MenuItem,
    value: number
  ) => {
    const updatedSelectedMenuItemList = selectedMenuItemList.map(
      (item: MenuItem) => {
        if (item.id === chooseItem.id) {
          return {
            ...item,
            quantity: (item?.quantity ?? 0) + value,
          };
        }
        return item;
      }
    );
    setSelectedMenuItemList(updatedSelectedMenuItemList);
  };

  const handleDoneClick = async () => {
    if (typeof onDoneClick !== "function") return;
    setIsDoneLoading(true);
    try {
      await onDoneClick();
    } catch (e) {
      // parent handles errors/toasts
    } finally {
      // keep short delay to avoid flicker if desired (optional)
      setIsDoneLoading(false);
    }
  };

  const handleClearAllItems = () => {
    setOrderItems([]);

    setSingleMenuItemsList(
      singleMenuItemsList.map((item: MenuItem) => ({ ...item, quantity: 0 }))
    );
    setComboItemList(
      comboItemList.map((item: any) => ({ ...item, quantity: 0 }))
    );
    setCustomMenuItemList(
      customMenuItemList.map((item: any) => ({ ...item, quantity: 0 }))
    );
    setSelectedMenuItemList(
      selectedMenuItemList.map((item: MenuItem) => ({ ...item, quantity: 0 }))
    );

    setShowClearConfirm(false);
    toast.success("All items have been cleared.");
  };

  const handleAddSItem = (chooseItem: MenuItem) => {
    if (!isCanCollectItems) {
      toast.warning("Please select all Required fields before collecting items.");
      return;
    }

    const orderDateRaw = watch("date");
    // For scheduled orders, prioritize deliveryDate prop over watch("date")
    const orderDate = isScheduledOrder && deliveryDate
      ? new Date(deliveryDate)
      : orderDateRaw
        ? new Date(orderDateRaw)
        : null;

    const availableDays: number[] = Array.isArray(chooseItem.availableDays)
      ? chooseItem.availableDays
      : [];

    const dayIndex = orderDate?.getDay();

    if (isScheduledOrder && orderDate && typeof dayIndex === "number") {
      const isAvailable = availableDays.length > 0 && availableDays.includes(dayIndex);

      if (!isAvailable) {
        setName(chooseItem.displayName || "This item");
        setAvailableDays(availableDays);
        setShowAvailabilityModal(true);
        return;
      }
    } else {

      const todayIndex = new Date().getDay();
      const isAvailableToday = availableDays.length > 0 && availableDays.includes(todayIndex);
      if (!isAvailableToday) {
        setName(chooseItem.displayName || "This item");
        setAvailableDays(availableDays);
        setShowAvailabilityModal(true);
        return;
      }
    }

    // Define portion details first
    const defaultPortion = chooseItem.portions && chooseItem.portions[0];
    const additionalCost =
      selectedPortions[chooseItem.id]?.additionalCost || defaultPortion?.additionalCost || 0;
    const portionLabel =
      selectedPortions[chooseItem.id]?.label || defaultPortion?.displayName || "";

    // Check inventory availability before adding item
    // const currentItemInOrder = orderItems.find(
    //   (item: MenuItem) =>
    //     (item?.id || item?.menuItemId) === chooseItem.id && (item?.portionLabel || "") === portionLabel
    // );
    // const currentQuantity = currentItemInOrder?.quantity || 0;
    // const newQuantity = currentQuantity + 1;

    // const inventoryCheck = checkInventoryAvailability(chooseItem.id, newQuantity);

    // if (!inventoryCheck.available) {
    //   toast.warning(inventoryCheck.message || `Insufficient inventory for ${chooseItem.displayName}`, {
    //     autoClose: 4000,
    //   });
    //   // Allow admins to proceed despite insufficient inventory
    // }

    const selectedItem = chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE
      ? getDefaultCustomOrderItemIndex(chooseItem, portionLabel)
      : orderItems?.findIndex(
        (item: MenuItem) =>
          (item?.id || item?.menuItemId) === chooseItem.id && (item?.portionLabel || "") === portionLabel
      );

    const value = 1;

    if (selectedItem === -1) {
      // Check if there's already an order item with this ID (even with different portion)
      const existingItemWithSameId = chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE
        ? null
        : orderItems.find(
          (item: MenuItem) => (item?.id || item?.menuItemId) === chooseItem.id
        );

      if (existingItemWithSameId) {
        // If there's an existing item with same ID but different portion, update it instead of creating new
        const updatedOrderItems = orderItems.map((item: MenuItem) => {
          if ((item?.id || item?.menuItemId) === chooseItem.id) {
            return {
              ...item,
              quantity: (item?.quantity ?? 0) + 1,
              calculatedPrice: item.overridePrice !== undefined ? item.overridePrice : item.price + additionalCost,
              portionLabel,
              // Preserve existing customItems, or initialize empty array for custom menu items
              ...(item.customItems ? { customItems: item.customItems } :
                (chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE ? { customItems: [] } : {})),
              // For custom menu items, set customItemTotal to base price if no customItems
              ...(chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE ? { customItemTotal: chooseItem.price + additionalCost } : {})
            };
          }
          return item;
        });
        setOrderItems(updatedOrderItems);
      } else {
        // Truly new item
        const addedOrderItemObj = {
          ...chooseItem,
          quantity: 1,
          calculatedPrice: chooseItem.overridePrice !== undefined ? chooseItem.overridePrice : chooseItem.price + additionalCost,
          portionLabel,
          menuId: selectedMenu?.id || null,
          // For custom menu items, initialize with empty customItems array
          ...(chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE ? {
            customItems: [],
            customItemTotal: chooseItem.price + additionalCost,
            customVariantKey: DEFAULT_CUSTOM_VARIANT_KEY
          } : {})
        };
        const newOrderItemArray = [...orderItems, addedOrderItemObj];
        setOrderItems(newOrderItemArray);
      }

      handleUpdatedMenuItemsList(chooseItem, value);
      handleUpdatedSelectedMenuItemList(chooseItem, value);
    } else {
      const updatedOrderItems = orderItems.map((item: MenuItem) => {
        if (isSameOrderItemVariant(item, chooseItem, portionLabel, DEFAULT_CUSTOM_VARIANT_KEY)) {
          return {
            ...item,
            quantity: (item?.quantity ?? 0) + 1,
            calculatedPrice: item.price + additionalCost,
            portionLabel,
            // Preserve customItems if they exist, or initialize empty array for custom menu items
            ...(item.customItems ? { customItems: item.customItems } :
              (chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE ? { customItems: [] } : {})),
            // For custom menu items, set customItemTotal to base price if no customItems
            ...(chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE ? { customItemTotal: chooseItem.price + additionalCost } : {})
          };
        }
        return item;
      });
      setOrderItems(updatedOrderItems);

      handleUpdatedMenuItemsList(chooseItem, value);
      handleUpdatedSelectedMenuItemList(chooseItem, value);
    }
  };


  const handleRemoveItem = (chooseItem: MenuItem) => {
    const value = -1;
    const defaultPortion = chooseItem.portions && chooseItem.portions[0];
    const currentPortionLabel =
      selectedPortions[chooseItem.id]?.label || defaultPortion?.displayName || "";

    const updatedOrderItems = orderItems
      .map((item: MenuItem) => {
        if (isSameOrderItemVariant(item, chooseItem, currentPortionLabel, DEFAULT_CUSTOM_VARIANT_KEY)) {
          const newQuantity = (item.quantity ?? 1) - 1;
          return {
            ...item,
            quantity: newQuantity,
            // Preserve customItems if they exist, or maintain empty array for custom menu items
            ...(item.customItems ? { customItems: item.customItems } :
              (chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE ? { customItems: [] } : {})),
            // For custom menu items, maintain customItemTotal
            ...(chooseItem.itemType === CUSTOM_MENU_ITEM_TYPE && item.customItems ? { customItems: item.customItems } : {})
          };
        }
        return item;
      })
      .filter((item: MenuItem) => item.quantity && item.quantity > 0);

    setOrderItems(updatedOrderItems);

    handleUpdatedMenuItemsList(chooseItem, value);
    handleUpdatedSelectedMenuItemList(chooseItem, value);
  };

  const toggleRowExpansion = (id: string) => {
    setExpandedRows((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const renderCustomMenuDetails = (item: MenuItem) => {
    // const updatedCustomMenuItemsList = customMenuItemList.filter((customItem) =>
    //   selectedMenuItemList.some((item) => item.id === customItem.id)
    // );

    // Get the actual quantity from orderItems to ensure consistency across filtered and unfiltered views
    const getItemQuantity = (item: MenuItem) => {
      const defaultPortion = item.portions && item.portions[0];
      const portionLabel = selectedPortions[item.id]?.label || defaultPortion?.displayName || "";

      const orderItem = item.itemType === CUSTOM_MENU_ITEM_TYPE
        ? getDefaultCustomOrderItem(item, portionLabel)
        : orderItems.find(
          (orderItem: MenuItem) =>
            (orderItem?.id || orderItem?.menuItemId) === item.id &&
            (orderItem?.portionLabel || "") === portionLabel
        );

      return orderItem?.quantity || 0;
    };

    const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newQuantity = parseInt(e.target.value) || 0;

      if (newQuantity < 0) return; // Prevent negative numbers

      // Check inventory availability before updating quantity
      if (newQuantity > 0) {
        // const inventoryCheck = checkInventoryAvailability(item.id, newQuantity);

        // if (!inventoryCheck.available) {
        //   toast.warning(inventoryCheck.message || `Insufficient inventory for ${item.displayName}`, {
        //     autoClose: 4000,
        //   });
        //   // Allow admins to proceed despite insufficient inventory
        // }
      }

      // Find the item in orderItems
      const defaultPortion = item.portions && item.portions[0];
      const additionalCost =
        selectedPortions[item.id]?.additionalCost || defaultPortion?.additionalCost || 0;
      const portionLabel =
        selectedPortions[item.id]?.label || defaultPortion?.displayName || "";

      const itemIndex = item.itemType === CUSTOM_MENU_ITEM_TYPE
        ? getDefaultCustomOrderItemIndex(item, portionLabel)
        : orderItems.findIndex(
          (orderItem: MenuItem) =>
            (orderItem?.id || orderItem?.menuItemId) === item.id &&
            (orderItem?.portionLabel || "") === portionLabel
        );

      if (itemIndex === -1 && newQuantity > 0) {
        // Item not in order, but check if there's an existing item with same ID
        const existingItemWithSameId = item.itemType === CUSTOM_MENU_ITEM_TYPE
          ? null
          : orderItems.find(
            (orderItem: MenuItem) => (orderItem?.id || orderItem?.menuItemId) === item.id
          );

        if (existingItemWithSameId) {
          // Update existing item instead of creating new one
          const updatedOrderItems = orderItems.map((orderItem: MenuItem) => {
            if ((orderItem?.id || orderItem?.menuItemId) === item.id) {
              return {
                ...orderItem,
                quantity: newQuantity,
                calculatedPrice: item.price + additionalCost,
                portionLabel,
                // Preserve customItems, or initialize empty array for custom menu items
                ...(orderItem.customItems ? { customItems: orderItem.customItems } :
                  (item.itemType === CUSTOM_MENU_ITEM_TYPE ? { customItems: [] } : {})),
                // For custom menu items, set customItemTotal to base price if no customItems
                ...(item.itemType === CUSTOM_MENU_ITEM_TYPE ? { customItemTotal: item.price + additionalCost } : {})
              };
            }
            return orderItem;
          });
          setOrderItems(updatedOrderItems);
        } else {
          // Truly new item
          const addedOrderItemObj = {
            ...item,
            quantity: newQuantity,
            calculatedPrice: item.price + additionalCost,
            portionLabel,
            // For custom menu items, initialize with empty customItems array
            ...(item.itemType === CUSTOM_MENU_ITEM_TYPE ? {
              customItems: [],
              customItemTotal: item.price + additionalCost,
              customVariantKey: DEFAULT_CUSTOM_VARIANT_KEY
            } : {})
          };
          setOrderItems([...orderItems, addedOrderItemObj]);
        }
      } else if (itemIndex !== -1) {
        // Item exists in order, update or remove it
        if (newQuantity === 0) {
          // Remove item if quantity is 0
          setOrderItems(orderItems.filter(
            (orderItem: MenuItem, index: number) => index !== itemIndex
          ));
        } else {
          // Update quantity
          const updatedOrderItems = [...orderItems];
          updatedOrderItems[itemIndex] = {
            ...updatedOrderItems[itemIndex],
            quantity: newQuantity,
            // Preserve customItems during quantity update, or initialize empty array for custom menu items
            ...(updatedOrderItems[itemIndex].customItems ? { customItems: updatedOrderItems[itemIndex].customItems } :
              (item.itemType === CUSTOM_MENU_ITEM_TYPE ? { customItems: [] } : {})),
            // For custom menu items, maintain customItemTotal
            ...(item.itemType === CUSTOM_MENU_ITEM_TYPE && updatedOrderItems[itemIndex].customItemTotal ?
              { customItemTotal: updatedOrderItems[itemIndex].customItemTotal } : {})
          };
          setOrderItems(updatedOrderItems);
        }
      }

      // Update the menu items lists
      const currentQuantity = getItemQuantity(item);
      const value = newQuantity - currentQuantity;
      if (value !== 0) {
        handleUpdatedMenuItemsList(item, value);
        handleUpdatedSelectedMenuItemList(item, value);
      }
    };

    const currentQuantity = getItemQuantity(item);

    if (item.itemType === SINGLE_ITEM_TYPE) {
      return (
        <div className="d-flex justify-content-end align-items-center">
          <Button
            className="plus-button"
            onClick={() => handleRemoveItem(item)}
            variant="light"
            size={"sm"}
            disabled={currentQuantity === 0}
          >
            <FontAwesomeIcon
              icon={currentQuantity === 1 ? faTrash : faMinus}
              title={"Remove Item"}
            />
          </Button>
          <input
            type="number"
            min="0"
            value={currentQuantity}
            onChange={handleQuantityChange}
            className="quantity-input mx-2 text-center"
            style={{ width: '80px' }}
          />
          <Button
            className="plus-button"
            onClick={() => handleAddSItem(item)}
            variant="light"
            size={"sm"}
          >
            <FontAwesomeIcon icon={faPlus} title={"Add Item"} />
          </Button>
        </div>
      );
    } else if (item.itemType === SET_MENU_ITEM_TYPE) {
      return (
        <div className="d-flex justify-content-end align-items-center">
          <Button
            className="plus-button"
            onClick={() => handleRemoveItem(item)}
            variant="light"
            size={"sm"}
            disabled={currentQuantity === 0}
          >
            <FontAwesomeIcon
              icon={currentQuantity === 1 ? faTrash : faMinus}
              title={"Remove Item"}
            />
          </Button>
          <input
            type="number"
            min="0"
            value={currentQuantity}
            onChange={handleQuantityChange}
            className="quantity-input mx-2 text-center"
            style={{ width: '50px' }}
          />
          <Button
            className="plus-button"
            onClick={() => handleAddSItem(item)}
            variant="light"
            size={"sm"}
          >
            <FontAwesomeIcon icon={faPlus} title={"Add Item"} />
          </Button>
        </div>
      );
    } else {
      return (
        <div className="d-flex justify-content-end align-items-center">
          <Button
            className="plus-button"
            onClick={() => handleRemoveItem(item)}
            variant="light"
            size={"sm"}
            disabled={
              (currentQuantity === 0) ||
              (customMenuItemList.some(
                (customItem) => customItem.id === item.id
              ) &&
                (customizedCustomItem?.id !== item.id || addItemLength === 0) &&
                orderByWatcher?.value! === "User")
            }
          >
            <FontAwesomeIcon
              icon={currentQuantity === 1 ? faTrash : faMinus}
              title={"Remove Item"}
            />
          </Button>
          <input
            type="number"
            min="0"
            value={currentQuantity}
            onChange={handleQuantityChange}
            className="quantity-input mx-2 text-center"
            style={{ width: '50px' }}
          />
          <Button
            className="plus-button"
            onClick={() => handleAddSItem(item)}
            variant="light"
            size={"sm"}
          >
            <FontAwesomeIcon icon={faPlus} title={"Add Item"} />
          </Button>
        </div>
      );
    }
  };

  const expandedRowsRenderer = (row: MenuItem) => {
    if (
      row.itemType === SET_MENU_ITEM_TYPE &&
      row?.items &&
      expandedRows[row.id]
    ) {
      return row.items.map((comboItem: any, idx: number) => (
        <tr
          key={`${row.id}-${idx}`}
          className="custom-item-row-styles"
          style={{ backgroundColor: "grey" }}
        >
          <td>
            <img
              src={
                Array.isArray(comboItem.imageUrl)
                  ? comboItem.imageUrl[0]
                  : comboItem.imageUrl
              }
              alt="Product"
              className="menu-combo-image"
            />
          </td>
          <td>{comboItem.displayName}</td>
          <td align="right">{comboItem.price?.toFixed(2)}</td>
          <td align="right">
            {(
              parseFloat(comboItem.price?.toFixed(2) || "0") *
              parseFloat(row.quantity?.toFixed(2) || "0")
            ).toFixed(2)}
          </td>
        </tr>
      ));
    } else if (
      row.itemType === CUSTOM_MENU_ITEM_TYPE &&
      row?.items &&
      expandedRows[row.id]
    ) {
      return row.items.map((comboItem: any, idx: number) => (
        <tr
          key={`${row.id}-${idx}`}
          className="custom-item-row-styles"
          style={{ backgroundColor: "grey" }}
        >
          <td>
            <img
              src={
                Array.isArray(comboItem.imageUrl)
                  ? comboItem.imageUrl[0]
                  : comboItem.imageUrl
              }
              alt="Product"
              className="menu-combo-images"
            />
          </td>
          <td>{comboItem.displayName}</td>
          <td align="right">{comboItem.price?.toFixed(2)}</td>
          <td align="right">
            {(
              parseFloat(comboItem.price?.toFixed(2) || "0") *
              parseFloat(row.quantity?.toFixed(2) || "0")
            ).toFixed(2)}
          </td>
          <td></td>
        </tr>
      ));
    }
    return null;
  };

  const hadaleSetupCustomItems = (CustomItem: MenuItem) => {
    setShowModal(true);
    setSelectedCustomItem(CustomItem);

    const obj: CustomizedCustom = {
      availableDays: CustomItem.availableDays,
      priceType: CustomItem.priceType,
      sections: CustomItem.sections,
      totalItems:
        CustomItem?.totalItems !== undefined ? CustomItem?.totalItems : 0,
      isAvailable: CustomItem?.isAvailable,
      id: CustomItem.id,
      displayName: CustomItem.displayName,
      price: CustomItem.price,
      collectedItems: [],
    };
    setCustomizedCustomItem(obj);
  };

  const handleSaveCollectedItems = (collectedItems: MenuItem[]) => {
    const updatedOrderItems = [...orderItems];
    collectedItems.forEach((newItem) => {
      const existingItemIndex = updatedOrderItems.findIndex(
        (item) => item.id === newItem.id
      );
      // Add menuId if not already present
      const itemWithMenuId = {
        ...newItem,
        menuId: newItem.menuId || selectedMenu?.id || null
      };
      if (existingItemIndex !== -1) {
        updatedOrderItems[existingItemIndex].quantity += itemWithMenuId.quantity;
      } else {
        updatedOrderItems.push(itemWithMenuId);
      }
    });
    setOrderItems(updatedOrderItems);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };
  const handleMenuClick = (menu: Menu, isMenuCardEnabled: boolean) => {
    if (isMenuCardEnabled) {
      hadaleSelectedMenu(menu);
    } else {
      toast.warning(
        "This menu is not available at this time. Please check the scheduled order time."
      );
    }
  };
  const formatTime = (time: string) => {
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? "P.M" : "A.M";
    const formattedHours = hours % 12 || 12;
    return `${formattedHours}:${String(minutes).padStart(2, "0")} ${period}`;
  };

  // Helper function to check if corporate menu has available items for selected organization
  const hasCorporateItemsForOrganization = (menu: Menu) => {
    if (menu.displayName?.toLowerCase() !== "corporate") {
      return true; // Non-corporate menus are always shown
    }

    const selectedOrganizationId = watch("organizationId") || organizationId;

    if (!selectedOrganizationId) {
      return false; // No organization selected, hide corporate menu
    }
    // Check if any menu items are available for the selected organization
    const hasAvailableItems = menu.items.some((item) => {
      if (item.itemType === "MenuItem") {
        const singleItem = singleMenuItemsList.find(
          (singleMenuItem) => item?.itemId === singleMenuItem?.id
        );
        return singleItem &&
          singleItem.isCooporateProduct &&
          singleItem.organizationIds &&
          Array.isArray(singleItem.organizationIds) &&
          singleItem.organizationIds.includes(selectedOrganizationId);
      } else if (item.itemType === "SetMenu") {
        const comboItem = comboItemList.find(
          (comboItem) => item?.itemId === comboItem?.id
        );
        return comboItem &&
          comboItem.isCooporateProduct &&
          comboItem.organizationIds &&
          Array.isArray(comboItem.organizationIds) &&
          comboItem.organizationIds.includes(selectedOrganizationId);
      } else {
        const customizeItem = customMenuItemList.find(
          (customMenuItem) => item?.itemId === customMenuItem?.id
        );
        return customizeItem &&
          customizeItem.isCooporateProduct &&
          customizeItem.organizationIds &&
          Array.isArray(customizeItem.organizationIds) &&
          customizeItem.organizationIds.includes(selectedOrganizationId);
      }
    });

    return hasAvailableItems;
  };

  const handleFilter = (e: any) => {
    const raw = e?.target?.value || "";
    const value = String(raw).toLowerCase();
    setSearchValue(value);

    if (!value) {
      setSelectedMenuItemList([]);
      return;
    }

    // Determine effective day index: if scheduled order + date provided use that date, otherwise use today
    const orderDateRaw = watch("date");
    // For scheduled orders, prioritize deliveryDate prop over watch("date")
    const orderDate = isScheduledOrder && deliveryDate
      ? new Date(deliveryDate)
      : orderDateRaw
        ? new Date(orderDateRaw)
        : null;
    const effectiveDayIndex =
      isScheduledOrder && orderDate ? orderDate.getDay() : new Date().getDay();

    // Collect item IDs that belong to available menus, add-on menus, or corporate menus (when organization is selected)
    const availableMenuItemIds = new Set<string>();
    const selectedOrganizationId = organizationId || watch("organizationId");
    menus
      .filter((menu) => {
        // Include available menus or add-on menus
        // const isAddOnMenu = menu.displayName?.toLowerCase() === "add on" ||
        //   menu.displayName?.toLowerCase() === "addon" ||
        //   menu.displayName?.toLowerCase() === "add-on" || menu.displayName?.toLowerCase() === "rasa bath plus";
        const isAddOnMenu = menu?.supportedApps?.includes("Admin");
        const isCorporateMenu = menu.displayName?.toLowerCase() === "corporate";

        // Include corporate menus only if an organization is selected
        const includeCorporateMenu = isCorporateMenu && selectedOrganizationId;

        return menu?.isAvailable || isAddOnMenu || includeCorporateMenu;
      })
      .forEach((menu) => {
        menu.items?.forEach((mi: any) => {
          // menu item reference may be itemId
          if (mi?.itemId) availableMenuItemIds.add(mi.itemId);
        });
      });

    const filterItems = (items: any[], itemType: string) => {
      return items
        .filter((item) => {
          // Exclude if item explicitly not available
          if (!item?.isAvailable) return false;

          // Exclude if item's parent menu is not available
          // if (!availableMenuItemIds.has(item.id)) return false;

          // Exclude if item has specific availableDays and does not include effectiveDayIndex
          const availableDays: number[] = Array.isArray(item.availableDays)
            ? item.availableDays
            : [];
          const isAvailableOnEffectiveDay =
            availableDays.length > 0 && availableDays.includes(effectiveDayIndex);
          if (!isAvailableOnEffectiveDay) return false;

          // Enhanced free text search: split search terms and check if all terms match
          const searchTerms = value.toLowerCase().split(/\s+/).filter(term => term.length > 0);
          const displayName = item.displayName?.toLowerCase() || "";
          const description = item.description?.toLowerCase() || "";
          const category = item.category?.toLowerCase() || "";
          const productId = (item as any).productId?.toLowerCase() || "";
          const foodAttributes =
            item.foodAttributes?.map((attr: string) => attr.toLowerCase()) || [];
          const portions =
            item.portions?.map((portion: { displayName: string }) =>
              portion.displayName.toLowerCase()
            ) || [];

          // Check if all search terms are found in any of the item fields
          return searchTerms.every(searchTerm => {
            return displayName.includes(searchTerm) ||
              description.includes(searchTerm) ||
              category.includes(searchTerm) ||
              productId.includes(searchTerm) ||
              foodAttributes.some((attr: string) => attr.includes(searchTerm)) ||
              portions.some((portion: string) => portion.includes(searchTerm));
          });
        })
        .map((item) => ({
          ...withMenuOverridePrice(item),
          itemType,
        }));
    };

    const singleMenuFiltered = filterItems(singleMenuItemsList, SINGLE_ITEM_TYPE);
    const comboMenuFiltered = filterItems(comboItemList, SET_MENU_ITEM_TYPE);
    const customMenuFiltered = filterItems(customMenuItemList, CUSTOM_MENU_ITEM_TYPE);
    const updatedData = [
      ...singleMenuFiltered,
      ...comboMenuFiltered,
      ...customMenuFiltered,
    ];
    setSelectedMenuItemList(updatedData);
  };

  const handleSearchFocus = () => {
    // Simple and reliable scroll to input functionality
    if (searchInputRef.current) {
      setTimeout(() => {
        try {
          // Try to get the input element directly or find it within the component
          let targetElement = searchInputRef.current;

          // If it's a reactstrap Input component, try to find the actual input element
          if (targetElement && !targetElement.getBoundingClientRect) {
            const inputElement = targetElement.querySelector?.('input') ||
              targetElement.getElementsByTagName?.('input')[0];
            if (inputElement) {
              targetElement = inputElement;
            }
          }

          // If we still don't have a valid element, use the parent container
          if (!targetElement || typeof targetElement.getBoundingClientRect !== 'function') {
            // Find the search input container in the DOM as fallback
            const searchContainer = document.querySelector('input[placeholder="Search items ..."]');
            if (searchContainer) {
              targetElement = searchContainer;
            }
          }

          if (targetElement && typeof targetElement.getBoundingClientRect === 'function') {
            // Scroll the element into view with some offset
            const rect = targetElement.getBoundingClientRect();
            const absoluteTop = window.pageYOffset + rect.top;
            const scrollToPosition = absoluteTop - 20; // 20px from top

            window.scrollTo({
              top: scrollToPosition,
              behavior: 'smooth'
            });

          } else {
            // Fallback: just scroll to a reasonable position
            window.scrollTo({
              top: 400, // Approximate position based on your layout
              behavior: 'smooth'
            });
          }
        } catch (error) {
          console.error('Error during scroll:', error);
          // Ultimate fallback
          window.scrollTo({
            top: 400,
            behavior: 'smooth'
          });
        }
      }, 100); // Increased timeout to ensure DOM is ready
    }
  };

  return (
    <div className="collect-items-step ">
      {/* Search Header */}


      {setFilteredData.length === 0 && (
        <Row>
          <Col md={12} className="menu-list">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="header-text3">{CREATE_ORDER_MENU_LIST_TITLE}</h5>
              <Button
                color="secondary"
                outline
                size="sm"
                onClick={() => setIsMenuListCollapsed(!isMenuListCollapsed)}
                className="ms-2"
              >
                <FontAwesomeIcon
                  icon={isMenuListCollapsed ? faChevronDown : faChevronUp}
                  className="me-1"
                />
                {isMenuListCollapsed ? 'Show Menus' : 'Hide Menus'}
              </Button>
            </div>
            {!isMenuListCollapsed && (
              <>
                {isInitialLoading ? (
                  <MenuListSkeleton />
                ) : (
                  <div className="scroll-container">
                    <button
                      className="scroll-button left"
                      onClick={() => scroll("left")}
                    >
                      <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    <div
                      className="menu-list-scrollable menu_list_col"
                      ref={scrollRef}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        overflowX: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {menus.map(
                        (menu: Menu, index: React.Key | null | undefined) => {
                          const [startTime, endTime] = menu.servingTime.split("-");
                          const formattedServingTime = `${formatTime(
                            startTime
                          )} - ${formatTime(endTime)}`;

                          // Check if this is a special menu type
                          const isCorporateMenu = menu.displayName?.toLowerCase() === "corporate";
                          // const isAddOnMenu = menu.displayName?.toLowerCase() === "add on" || menu.displayName?.toLowerCase() === "addon" || menu.displayName?.toLowerCase() === "add-on" || menu.displayName?.toLowerCase() === "rasa bath plus";
                          const isAddOnMenu = menu.supportedApps?.includes("Admin");


                          // Corporate menu logic - only show for organization orders with selected organization
                          if (isCorporateMenu) {
                            // Check if this is an organization order (either by orderBy selection or organizationId prop)
                            const isOrganizationOrder = orderByWatcher?.value?.toLowerCase() === "organization" || !!organizationId;
                            
                            if (!isOrganizationOrder) {
                              return null;
                            }
                            // Hide corporate menu if no items are available for selected organization
                            if (!hasCorporateItemsForOrganization(menu)) {
                              return null;
                            }
                          }

                          // Determine menu availability based on order type
                          let isMenuCardEnabled = false;

                          if (isCorporateMenu || isAddOnMenu) {
                            // Corporate and Add-on menus are always enabled
                            isMenuCardEnabled = true;
                          } else if (isScheduledOrder) {
                            // For scheduled orders, always enable the menu
                            isMenuCardEnabled = true;
                          } else {
                            // For immediate orders, check if current time is before the end time
                            const [endHours, endMinutes] = endTime.split(":").map(Number);
                            const endTimeDate = new Date();
                            endTimeDate.setHours(endHours, endMinutes, 0, 0);
                            const currentTime = new Date();
                            isMenuCardEnabled = currentTime <= endTimeDate;
                          }
                          return (
                            <React.Fragment key={index}>
                              {/* {((menu?.isAvailable && isAddOnMenu) || isCorporateMenu ) && ( */}
                              {((menu?.isAvailable) || isAddOnMenu || isCorporateMenu) && (
                                <div
                                  className="menu_card"
                                  style={{
                                    background: isMenuCardEnabled
                                      ? menu?.id === selectedMenu?.id
                                        ? "linear-gradient(to bottom right, white 30%, #f2f2f2 90%)"
                                        : "white"
                                      : "#e0e0e0",
                                    marginRight: "40px",
                                    opacity: isMenuCardEnabled ? 1 : 0.5,
                                  }}
                                  onClick={() =>
                                    handleMenuClick(menu, isMenuCardEnabled)
                                  }
                                >
                                  <div
                                    style={{
                                      backgroundColor:
                                        menu?.id === selectedMenu?.id
                                          ? "red"
                                          : "white",
                                      width: "4px",
                                    }}
                                  ></div>

                                  <div>
                                    <Label className="menu-name">
                                      {menu.displayName}
                                    </Label>
                                    <br />
                                    <div className="time-text-red">
                                      {formattedServingTime}
                                    </div>
                                    <Badge
                                      className="menu-badge"
                                      color={"warning"}
                                      style={{ opacity: 0.7 }}
                                    >
                                      <FontAwesomeIcon
                                        icon={faBowlFood}
                                        size={"sm"}
                                        color={"black"}
                                      />{" "}
                                      &nbsp;{menu?.dineType}
                                    </Badge>
                                  </div>
                                </div>
                              )}
                            </React.Fragment>
                          );
                        }
                      )}
                    </div>
                    <button
                      className="scroll-button right"
                      onClick={() => scroll("right")}
                    >
                      <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                  </div>
                )}
              </>
            )}
          </Col>
        </Row>
      )}

      <Row className="d-flex justify-content-end">
        {/* <Col>
          <h5 className="header-text mt-2">Create Order</h5>
        </Col> */}
        <Col lg="4" className="mt-2">
          <Input
            ref={searchInputRef}
            value={searchValue}
            onChange={handleFilter}
            onFocus={handleSearchFocus}
            placeholder="Search items by name or SKU/ Product ID..."
          />
        </Col>
      </Row>
      {/* Filter Tags Section */}
      {isFilterTagsLoading ? (
        <Row className="mt-4">
          <Col>
            <div className="filter-tags-container">
              <div className="d-flex align-items-center mb-3">
                <FontAwesomeIcon icon={faSliders} className="me-2" />
                <h6 className="mb-0 fw-bold">Filter Items</h6>
              </div>

              <div className="filter-tags-scroll-container">
                <div className="filter-tags-wrapper">
                  {/* Skeleton Loading for Filter Tags */}
                  {[...Array(8)].map((_, index) => (
                    <div
                      key={`skeleton-${index}`}
                      className="filter-tag-skeleton"
                      style={{
                        width: `${60 + Math.random() * 40}px`,
                        height: '32px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '16px',
                        margin: '0 8px 8px 0',
                        animation: 'pulse 1.5s ease-in-out infinite'
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        filterTagsData?.filterTags && Object.keys(filterTagsData.filterTags).length > 0 && (
          <Row className="mt-4">
            <Col>
              <div className="filter-tags-container">
                <div className="d-flex align-items-center mb-3">
                  <FontAwesomeIcon icon={faSliders} className="me-2" />
                  <h6 className="mb-0 fw-bold">Filter Items</h6>
                </div>

                <div className="filter-tags-scroll-container">
                  <div className="filter-tags-wrapper">
                    {/* All Filter Button */}
                    <button
                      className={`filter-tag-btn ${selectedFilterTags.length === 0 ? 'active' : ''
                        }`}
                      onClick={handleAllFilter}
                    >
                      All
                    </button>

                    {/* Filter Tags by Category */}
                    {Object.entries(filterTagsData.filterTags).map(([category, categoryData]: [string, any], categoryIndex: number) => {
                      const visibleTags = categoryData.tags?.filter((tag: any) => tag.show) || [];

                      if (visibleTags.length === 0) return null;

                      return (
                        <React.Fragment key={category}>
                          {/* Add separator before each category (except the first one) */}
                          {categoryIndex > 0 && (
                            <div className="filter-category-separator"></div>
                          )}

                          {visibleTags.map((tagObj: any, index: number) => {
                            const isSelected = selectedFilterTags.includes(tagObj.tag);

                            return (
                              <button
                                key={`${category}-${tagObj.tag}-${index}`}
                                className={`filter-tag-btn ${isSelected ? 'active' : ''
                                  }`}
                                onClick={() => handleTagFilter(tagObj, categoryData, category)}
                              >
                                {tagObj.tag}
                              </button>
                            );
                          })}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>

                {selectedFilterTags.length > 0 && (
                  <div className="mt-2">
                    <small className="text-muted">
                      {selectedFilterTags.length} filter{selectedFilterTags.length !== 1 ? 's' : ''} applied
                    </small>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        )
      )}

      <Col md={16} className="menu-name-items">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="header-text3 mt-3">
            {selectedFilterTags.length > 0
              ? `All Items (${selectedFilterTags.length} filter${selectedFilterTags.length !== 1 ? 's' : ''} applied)`
              : selectedMenu?.displayName
                ? `${selectedMenu.displayName} Items`
                : "Items"
            }
          </h5>
        </div>
        <table className="table ">
          <thead className="table-header-gradient">
            <tr>
              <th className="fw-bold">Image</th>
              <th style={{ textAlign: "left" }}>Name</th>
              <th style={{ textAlign: "center" }}>Portions Size</th>
              <th style={{ textAlign: "center" }}>Unit Price (Rs.)</th>

              <th style={{ textAlign: "center", width: 150 }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {(() => {
              // Get items to display based on filter tags
              let itemsToDisplay: MenuItem[] = [];

              if (selectedFilterTags.length > 0) {
                // If filter tags are selected, show filtered items from ALL menu items
                const allMenuItems = [
                  ...singleMenuItemsList,
                  ...comboItemList,
                  ...customMenuItemList
                ].map((item) => withMenuOverridePrice(item));
                itemsToDisplay = filterBySelectedTag(allMenuItems);

              } else {
                // If no filter tags are selected, show selected menu items (current behavior)
                itemsToDisplay = selectedMenuItemList;
              }

              return itemsToDisplay.map((item: MenuItem, index) => (
                <React.Fragment key={item.id}>
                  <tr className="custom-item-row border-none">
                    <td>
                      <img
                        src={
                          Array.isArray(item.imageUrl)
                            ? getImageUrlWithFallback(item.imageUrl[0], DEFAULT_IMAGE_URL, 64)
                            : item.imageUrl
                        }
                        alt="Product"
                        className="menu-image"
                      />
                    </td>
                    <td>
                      <div className="d-flex justify-content-between">
                        <div>
                          <div className="mt-2">
                            <Label>{item?.displayName}</Label>
                          </div>

                          <span className="text-secondary fa-s">
                            {item?.itemType === SINGLE_ITEM_TYPE
                              ? "MenuItem"
                              : item?.itemType === SET_MENU_ITEM_TYPE
                                ? "Combo"
                                : "Custom"}
                          </span>

                          {/* Add availability status */}
                          {(() => {
                            const availableDays = Array.isArray(item.availableDays) ? item.availableDays : [];
                            const orderDateRaw = watch("date");
                            // For scheduled orders, prioritize deliveryDate prop over watch("date")
                            const orderDate = isScheduledOrder && deliveryDate
                              ? new Date(deliveryDate)
                              : orderDateRaw
                                ? new Date(orderDateRaw)
                                : null;

                            let isAvailable = true;
                            let unavailableDay = "Today";

                            if (isScheduledOrder && orderDate) {
                              const dayIndex = orderDate.getDay();
                              isAvailable = availableDays.length > 0 && availableDays.includes(dayIndex);

                              // Get the day name for the scheduled date
                              const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                              unavailableDay = dayNames[dayIndex];
                            } else {
                              const todayIndex = new Date().getDay();
                              isAvailable = availableDays.length > 0 && availableDays.includes(todayIndex);
                              unavailableDay = "Today";
                            }

                            if (!isAvailable) {
                              return (
                                <div className="text-muted" style={{ fontSize: '0.75rem', marginTop: '4px' }}>
                                  Not Available {unavailableDay}
                                </div>
                              );
                            }
                            return null;
                          })()}

                          {/* Inventory Status Badge - Only show for immediate orders */}
                          {!scheduledOrderDetails.isScheduledOrder && (() => {
                            const inventoryCheck = checkInventoryAvailability(item.id, 1);
                            const { availableCount, isLoading } = inventoryCheck;

                            if (isLoading) {
                              return (
                                <Badge color="secondary" className="ms-2" style={{ fontSize: '0.7rem' }}>
                                  Checking stock...
                                </Badge>
                              );
                            }

                            if (availableCount === 0) {
                              return (
                                <Badge color="danger" className="ms-2" style={{ fontSize: '0.7rem' }}>
                                  Out of Stock
                                </Badge>
                              );
                            } else if (availableCount > 0 && availableCount <= 10) {
                              return (
                                <Badge color="warning" className="ms-2" style={{ fontSize: '0.7rem' }}>
                                  Low Stock ({availableCount} left)
                                </Badge>
                              );
                            } else if (availableCount > 10) {
                              return (
                                <Badge color="success" className="ms-2" style={{ fontSize: '0.7rem' }}>
                                  Stock Available({availableCount} left)
                                </Badge>
                              );
                            }
                            return null;
                          })()}
                        </div>

                        <div>
                          {item.itemType === SET_MENU_ITEM_TYPE && (
                            <Button
                              className="setMenu-button "
                              size={"sm"}
                              variant="primary"
                              onClick={() => toggleRowExpansion(item.id)}
                              aria-expanded={expandedRows[item.id]}
                              aria-controls={`custom-items-${item.id}`}
                            >
                              <FontAwesomeIcon
                                icon={
                                  expandedRows[item.id]
                                    ? faChevronUp
                                    : faChevronDown
                                }
                              />
                            </Button>
                          )}

                          {item.itemType === CUSTOM_MENU_ITEM_TYPE &&
                            orderByWatcher?.value !== "CartPerson" && (
                              <Button
                                className="setMenu-button"
                                size={"sm"}
                                variant="primary"
                                onClick={() => hadaleSetupCustomItems(item)}
                              >
                                <FontAwesomeIcon icon={faSliders} />
                              </Button>
                            )}
                        </div>
                      </div>
                    </td>
                    <td align="center">
                      {item.portions && item.portions.length > 0 && (
                        <ControlledSelect
                          label=""
                          inputName={`portionSize_${item.id}`}
                          control={control}
                          isMulti={false}
                          optionsList={item.portions.map((portion) => ({
                            label: portion.displayName,
                            value: portion.additionalCost,
                          }))}
                          onSelectChange={(selectedOption) =>
                            handlePortionSelect(
                              item.id,
                              selectedOption?.value || 0,
                              selectedOption?.label || ""
                            )
                          }
                          defaultSelectedValue={{
                            label: item.portions[0].displayName,
                            value: item.portions[0].additionalCost,
                          }}
                        />
                      )}
                    </td>

                    <td align="center">
                      {(((item as any).overridePrice ?? (item as any).ovrridePrice ?? item.price ?? 0) + (selectedPortions[item.id]?.additionalCost || 0)).toFixed(2)}
                    </td>

                    <td>{renderCustomMenuDetails(item)}</td>
                  </tr>
                  {expandedRowsRenderer(item)}
                </React.Fragment>
              ));
            })()}
          </tbody>
        </table>
        <div className="d-flex flex-column align-items-end mb-3">
          {/* Error message for Done button */}
          {manualDeliveryFeeError && manualDeliveryFeeError !== "" && (
            <div className="text-danger small mb-2" style={{ textAlign: 'right' }}>
              <i className="fas fa-exclamation-triangle"></i> {manualDeliveryFeeError}
            </div>
          )}
          {manualDiscountError && manualDiscountError !== "" && (
            <div className="text-danger small mb-2" style={{ textAlign: 'right' }}>
              <i className="fas fa-exclamation-triangle"></i> {manualDiscountError}
            </div>
          )}

          <div className="d-flex gap-2">
            <Button
              color="danger"
              outline
              onClick={() => setShowClearConfirm(true)}
              disabled={orderItems.length === 0}
              title="Remove all added items"
            >
              <FontAwesomeIcon icon={faTrash} className="me-2" />
              Clear Items
            </Button>

            <Button onClick={handleDoneClick} color="success" disabled={isDoneLoading || !!(manualDeliveryFeeError && manualDeliveryFeeError !== "") || !!(manualDiscountError && manualDiscountError !== "")}>
              {isDoneLoading ? (
                <>
                  <FontAwesomeIcon icon={faSpinner} spin className="me-2" />{"Loading..."}
                </>
              ) : (
                "Confirm Items"
              )}
            </Button>
          </div>
        </div>
      </Col>
      <CustomItemSetupModal
        showModal={showModal}
        handleModalClose={handleModalClose}
        selectedCustomItem={selectedCustomItem}
        setSelectedCustomItem={setSelectedCustomItem}
        singleMenuItemsList={singleMenuItemsList}
        control={control}
        customizedCustomItem={customizedCustomItem}
        setCustomizedCustomItem={setCustomizedCustomItem}
        onSaveCollectedItems={handleSaveCollectedItems}
        sendCustomObj={sendCustomObj}
        setSendCustomObj={setSendCustomObj}
        orderItems={orderItems}
        setOrderItems={setOrderItems}
        selectedMenuItemList={selectedMenuItemList}
        setSelectedMenuItemList={setSelectedMenuItemList}
        customMenuItemList={customMenuItemList}
        setCustomMenuItemList={setCustomMenuItemList}
        watch={watch}
        cartSummariesData={cartSummariesData}
        isDeliveryOrder={isDeliveryOrder}
        cartId={cartId}
        deliveryDate={deliveryDate}
      />
      <Modal
        show={showAvailabilityModal}
        onHide={() => setShowAvailabilityModal(false)}
        centered
        backdrop="static"
        className="availability-modal"
      >
        <Modal.Header closeButton className="availability-modal-header">
          <Modal.Title>Item Not Available {(() => {
            const isScheduledOrderValue = watch("isScheduledOrder");
            const orderDateRaw = watch("date");
            const orderDate = orderDateRaw ? new Date(orderDateRaw) : null;

            if (isScheduledOrderValue && orderDate) {
              const dayIndex = orderDate.getDay();
              const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
              return dayNames[dayIndex];
            }
            return "Today";
          })()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="availability-modal-message">
            {name} is not available on {(() => {
              const isScheduledOrderValue = watch("isScheduledOrder");
              const orderDateRaw = watch("date") || scheduledOrderDetails.orderTimeSlot;
              const orderDate = orderDateRaw ? new Date(orderDateRaw) : null;

              if (isScheduledOrderValue && orderDate) {
                const dayIndex = orderDate.getDay();
                const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                return dayNames[dayIndex];
              }
              return getCurrentDayName();
            })()}.<br />
            Available days: {getAvailableDayNames(availableDays)}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAvailabilityModal(false)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Clear Items Confirmation Modal */}
      <Modal
        show={showClearConfirm}
        onHide={() => setShowClearConfirm(false)}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Clear All Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to remove all selected <strong>{orderItems.length}</strong> item
            {orderItems.length !== 1 ? "s" : ""} from the order? This action cannot be undone.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowClearConfirm(false)}>
            Cancel
          </Button>
          <Button color="danger" onClick={handleClearAllItems}>
            <FontAwesomeIcon icon={faTrash} className="me-2" />
            Clear All Items
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CollectItemsStep;
